var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRevenueChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 66.6v13.8H14.6V66.6h10.8M31 61H9v25h22V61zm22.4-19.4v38.8H42.6V41.6h10.8M59 36H37v50h22V36zm22.4-18.4v62.8H70.6V17.6h10.8M87 12H65v74h22V12z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NiA5NiI+CiAgPHBhdGggZD0iTTI1LjQgNjYuNnYxMy44SDE0LjZWNjYuNmgxMC44TTMxIDYxSDl2MjVoMjJWNjF6TTUzLjQgNDEuNnYzOC44SDQyLjZWNDEuNmgxMC44TTU5IDM2SDM3djUwaDIyVjM2ek04MS40IDE3LjZ2NjIuOEg3MC42VjE3LjZoMTAuOE04NyAxMkg2NXY3NGgyMlYxMnoiLz4KPC9zdmc+Cg==";
export { SvgRevenueChart as ReactComponent };